import {
  FieldsGroup,
  GetFieldsLocationsResponse,
  GetFieldsGroupsResponse,
} from 'types/Meteorology/Fields/TrackingForecast/Register/getFieldsLocations';

import {
  FieldsCity,
  GetCitiesResponse,
} from 'types/Meteorology/Fields/TrackingForecast/Register/getCities';

import type Location from 'types/Locations/Location';

export function transformGetFieldsLocationsResponse(
  response: GetFieldsLocationsResponse,
): Location[] {
  return response.data.map((location) => ({
    id: location.id,
    name: location.nome,
    latitude: location.latitude,
    longitude: location.longitude,
    cityId: location.city_id,
    shpPath: location.shp_path,
    createdAt: location.criado_em,
    groupId: location.grupo_id,
  }));
}

export function transformGetFieldsGroupsResponse(
  response: GetFieldsGroupsResponse,
): FieldsGroup[] {
  return response.data.map((group) => ({
    description: group.descricao,
    userId: group.user_id,
    createdAt: group.criado_em,
    name: group.nome,
    id: group.id,
  }));
}

export function transformGetCitiesResponse(
  response: GetCitiesResponse,
): FieldsCity[] {
  return response.data.map((city) => ({
    shpFilePath: city.shp_file_path,
    id: city.id,
    label: city.label,
    state: city.estado,
    name: city.nome,
  }));
}
